(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["innotech-contact"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const close = (root, focusTrigger = false) => {
      const trigger = root.querySelector('.it-enquiry__trigger');
      const list = root.querySelector('.it-enquiry__list');
      root.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      list.hidden = true;
      if (focusTrigger) trigger.focus();
    };
    const init = (root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const select = root.querySelector('select');
      const trigger = root.querySelector('.it-enquiry__trigger');
      const value = root.querySelector('.it-enquiry__value');
      const list = root.querySelector('.it-enquiry__list');
      const options = [...root.querySelectorAll('.it-enquiry__option')];
      const form = root.closest('form');
      const submit = form?.querySelector('.it-contact__submit');
      const syncSubmit = () => {
        const requiredFields = [...form.querySelectorAll('[required]')];
        const ready = requiredFields.length > 0 && requiredFields.every((field) => field.value.trim() !== '' && field.checkValidity());
        submit?.classList.toggle('is-ready', ready);
      };
      const open = () => {
        root.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        list.hidden = false;
        (options.find((option) => option.getAttribute('aria-selected') === 'true') || options[0]).focus();
      };
      const choose = (option) => {
        select.value = option.dataset.value;
        value.textContent = option.textContent.trim();
        options.forEach((item) => item.setAttribute('aria-selected', String(item === option)));
        select.dispatchEvent(new Event('change', { bubbles: true }));
        close(root, true);
      };
      trigger.addEventListener('click', () => root.classList.contains('is-open') ? close(root) : open());
      options.forEach((option, index) => {
        option.addEventListener('click', () => choose(option));
        option.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();
            options[(index + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length].focus();
          } else if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            choose(option);
          } else if (event.key === 'Escape') {
            event.preventDefault();
            close(root, true);
          }
        });
      });
      document.addEventListener('click', (event) => { if (!root.contains(event.target)) close(root); });
      form?.addEventListener('input', syncSubmit);
      form?.addEventListener('change', syncSubmit);
      syncSubmit();
    };
    const initAll = (scope = document) => scope.querySelectorAll('[data-it-enquiry]').forEach(init);
    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["innotech-header"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-it-language-picker][open]').forEach((picker) => {
      if (!picker.contains(event.target)) picker.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const picker = event.target.closest('[data-it-language-picker][open]');
    if (!picker) return;
    picker.removeAttribute('open');
    picker.querySelector('summary').focus();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["innotech-market-path"] && !Shopify.designMode) return;
  try {
    
  class MarketPathSlider extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.track = this.querySelector('.imp__route');
      if (!this.track) return;
      this.dataset.ready = 'true';
      this.frame = null;
      this.handleScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.updateProgress();
        });
      };
      this.track.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleScroll);
      this.updateProgress();
    }

    disconnectedCallback() {
      if (!this.track || !this.handleScroll) return;
      this.track.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleScroll);
      if (this.frame) cancelAnimationFrame(this.frame);
    }

    updateProgress() {
      const maximum = this.track.scrollWidth - this.track.clientWidth;
      const progress = maximum > 0 ? this.track.scrollLeft / maximum : 0;
      this.style.setProperty('--imp-progress', Math.min(1, Math.max(0, progress)).toFixed(4));
    }
  }

  if (!customElements.get('market-path-slider')) {
    customElements.define('market-path-slider', MarketPathSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  if (!customElements.get('innotech-article-share')) {
    customElements.define('innotech-article-share', class extends HTMLElement {
      constructor() {
        super();
        this.copyLink = this.copyLink.bind(this);
      }
      connectedCallback() {
        this.addEventListener('click', this.copyLink);
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.copyLink);
      }
      async copyLink(event) {
        const control = event.target.closest('[data-copy-article]');
        if (!control || !this.contains(control)) return;
        const fallback = this.querySelector('.it-news-article__share-url');
        try {
          await navigator.clipboard.writeText(this.dataset.url);
          this.querySelector('[role="status"]').textContent = this.dataset.success;
          fallback.hidden = true;
        } catch {
          fallback.hidden = false;
          fallback.focus();
          fallback.select();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
